import React from "react";
import Form from "react-bootstrap/Form";

export default function SelectFields({
  data,
  onSeleccionMessage,
  OnLoadingMessage,
  onHandleSeleccion,
}) {
  //console.log(data, "soy data");

  const selectedValueFunction = (e) => {
    onHandleSeleccion(e);
  };

  return (
    <Form.Select
      onChange={(event) => {
        selectedValueFunction({
          value: event.currentTarget.value,
          name: event.currentTarget.options[
            event.currentTarget.selectedIndex
          ].getAttribute("name"),
        });
      }}
    >
      <option hidden>
        {data.length !== 0 ? onSeleccionMessage : OnLoadingMessage}
      </option>
      {data.map(({ name, id }, index) => {
        return (
          <option
            value={id}
            name={name}
            key={index}
            //onClick={selectedValueFunction}
          >
            {name}
          </option>
        );
      })}
    </Form.Select>
  );
}
